import axiosSecurity from '../axios/axiosSecurity'

export default class PerfilService {
  static async get() {
    return axiosSecurity.get('perfis').then(res => res.data.data)
  }

  static async getById(perfilId) {
    return axiosSecurity.get(`perfis/${perfilId}`).then(res => res.data.data)
  }

  static async criar(body) {
    return axiosSecurity.post('perfis', body)
  }

  static async update(perfilId, body) {
    return axiosSecurity.put(`perfis/${perfilId}`, body)
  }

  static async associarFuncionalidade(perfilId, body) {
    return axiosSecurity.put(`perfis/${perfilId}/funcionalidades`, body)
  }

  static async ativarOuInativar(perfilId, body) {
    return axiosSecurity.put(`perfis/${perfilId}/ativado`, body)
  }
}
